import { useCallback, useState } from 'react';

type ModalToggleEvent = Pick<Event, 'preventDefault' | 'stopPropagation'>;

export type ModalToggle = (event?: ModalToggleEvent) => void;

export default function useModal() {
  const [isOpen, setOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  return [
    isOpen,
    useCallback((event?: ModalToggleEvent) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      setScrollY(window.pageYOffset);
      setOpen(true);
    }, []),
    useCallback(
      (event?: ModalToggleEvent) => {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (isOpen) {
          window.scroll(0, scrollY);
          setScrollY(0);
        }

        if (isOpen) setOpen(false);
      },
      [isOpen, scrollY]
    )
  ] as [boolean, ModalToggle, ModalToggle];
}
